<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option
      v-for="type in selects"
      :key="type.id"
      :value="type.id"
      :selected="type.id == selected"
      >{{ type.name }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectTypes',
  data() {
    return {
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/invoice/types`).then((res) => (this.selects = res.data));
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
